import { render, staticRenderFns } from "./AdminScreen.vue?vue&type=template&id=33ff531b&scoped=true"
import script from "./AdminScreen.vue?vue&type=script&lang=js"
export * from "./AdminScreen.vue?vue&type=script&lang=js"
import style0 from "./AdminScreen.vue?vue&type=style&index=0&id=33ff531b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ff531b",
  null
  
)

export default component.exports